// Classes.
import {BaseComponentLocator} from './base.component-locator';

// Interfaces.
import {ComponentLocatorInterface} from '../interfaces/component-locator.interface';


export abstract class BooleanLocatorComponent extends BaseComponentLocator implements ComponentLocatorInterface {


  public constructor(protected _value: boolean = false) {
    super();
  };

  /**
   * value setter/getter.
   */
  set value(value: boolean) {
    this._value = value;
  }

  get value(): boolean {
    return this._value;
  }
}

